import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Video: React.FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M12 1.5C6.201 1.5 1.5 6.201 1.5 12C1.5 17.799 6.201 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.201 17.799 1.5 12 1.5ZM12 21C7.02975 21 3 16.9703 3 12C3 7.02975 7.02975 3 12 3C16.9703 3 21 7.02975 21 12C20.9947 16.968 16.968 20.9947 12.0007 21H12Z" />
    <path d="M9.75 8.10043V15.9004C9.75075 16.2649 10.0462 16.5604 10.4107 16.5604C10.5555 16.5604 10.689 16.5139 10.7978 16.4352L10.7955 16.4367L16.2247 12.5367C16.392 12.4152 16.5 12.2202 16.5 12.0004C16.5 11.7807 16.392 11.5857 16.227 11.4657L16.2247 11.4642L10.7955 7.56418C10.689 7.48693 10.5555 7.44043 10.4107 7.44043C10.0462 7.44043 9.75075 7.73593 9.75 8.10043Z" />
  </SvgIcon>
);
